export default "undo redo | casechange blocks | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlst checklist outdent indent  |insertdatetime |preview fullscreen export print | ia addSignature "